/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateLinkInput } from '../models/CreateLinkInput';
import type { GetQrBoardInput } from '../models/GetQrBoardInput';
import type { LinkResponseDTO } from '../models/LinkResponseDTO';
import type { QrBoardDTO } from '../models/QrBoardDTO';
import type { UpdateQrBoardInput } from '../models/UpdateQrBoardInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LinksService {
  /**
   * Create Link
   * @param requestBody
   * @returns LinkResponseDTO Successful Response
   * @throws ApiError
   */
  public static createShortLink(requestBody: CreateLinkInput): CancelablePromise<LinkResponseDTO> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/links',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * List Qr Boards
   * @param page Page number
   * @param perPage Items per page
   * @param search Search by label or short code
   * @returns QrBoardDTO Successful Response
   * @throws ApiError
   */
  public static listQrBoards(
    page: number = 1,
    perPage: number = 10,
    search?: string,
  ): CancelablePromise<Array<QrBoardDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/links/qr-board/list',
      query: {
        page: page,
        per_page: perPage,
        search: search,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Update Qr Board
   * @param requestBody
   * @returns QrBoardDTO Successful Response
   * @throws ApiError
   */
  public static updateQrBoard(requestBody: UpdateQrBoardInput): CancelablePromise<QrBoardDTO> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/links/qr-board',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Qr Board
   * @param requestBody
   * @returns QrBoardDTO Successful Response
   * @throws ApiError
   */
  public static getQrBoard(requestBody: GetQrBoardInput): CancelablePromise<QrBoardDTO> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/links/qr-board',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
